/*
 * @Date: 2021-01-28 11:09:32
 * @LastEditors: 孙强强
 * @LastEditTime: 2021-09-15 17:13:07
 */
import { setNativeInfo, getSyncNativeInfo } from "./untils";
const targetClass = "KTemaiJsConfig";
/**
 * @description: 获取经纬度
 * @param {*} iosGetlocation
 * @return {*}
 */
export const iosGetlocation = () => {
  let loc = window.localjs && window.localjs.getgps();
  let rsp = {};
  switch (`${loc}`) {
    case "-2":
      rsp = {
        code: -2,
        msg: "未开启定位服务",
      };
      break;
    case "-1":
      rsp = {
        code: -1,
        msg: "未开启定位权限",
      };
      break;
    case "0":
      rsp = {
        code: 0,
        msg: "无定位结果",
      };
      break;
    default:
      let res = (loc && loc.split("_")) || {};
      rsp = {
        code: 1,
        msg: "success",
        data: {
          lat: res[0],
          lng: res[1],
        },
      };
  }
  return rsp;
};
/**
 * @description: 设置页面标题
 * @param {*} iosSetTitle
 * @return {*}
 */
export const iosSetTitle = (title) => {
  setNativeInfo({
    methodName: "hzwSetTitle_",
    parm: [
      {
        parmClass: "s",
        parmValue: title || "",
      },
    ],
  });
};
/**
 * @description: 禁止和允许页面分享及刷新
 * @param {*} iosRefreshOrShare
 * @return {*}
 */
export const iosRefreshOrShare = ({ refresh = true, share = true } = {}) => {
  setNativeInfo({
    methodName: "hzwCanRefresh_canShare_",
    parm: [
      {
        parmClass: "i",
        parmValue: refresh ? "1" : "0",
      },
      {
        parmClass: "i",
        parmValue: share ? "1" : "0",
      },
    ],
  });
};
/**
 * @description: 设置app右上角按钮
 * @param {*} iosSetRightIcon
 * @return {*}
 */
export const iosSetRightIcon = (buttons = []) => {
  setNativeInfo({
    methodName: "hzwConfigRightButton_",
    parm: [
      {
        parmClass: "a",
        parmValue: buttons,
      },
    ],
  });
};
/**
 * @description: 复制文本
 * @param {*} iosCopyText
 * @return {*}
 */
export const iosCopyText = ({
  successMsg = "",
  errorMsg = "",
  text = "",
} = {}) => {
  let parm = {};
  if (successMsg || errorMsg) {
    parm = {
      targetClass,
      methodType: "1",
      methodName: "copyText_success_falid_",
      parm: [
        {
          parmClass: "s",
          parmValue: text,
        },
        {
          parmClass: "s",
          parmValue: successMsg || "复制成功",
        },
        {
          parmClass: "s",
          parmValue: errorMsg || "复制失败",
        },
      ],
    };
  } else {
    parm = {
      targetClass,
      methodName: "copyText_",
      parm: [
        {
          parmClass: "s",
          parmValue: text,
        },
      ],
    };
  }
  setNativeInfo(parm);
};
/**
 * @description: 拉起小程序
 * @param {*} iosOpenMin
 * @return {*}
 */
export const iosOpenMin = ({ username = "", path = "", type = 0 } = {}) => {
  setNativeInfo({
    targetClass,
    methodType: 1,
    methodName: "openMiniProgramWithUserName_path_miniProgramType_",
    parm: [
      {
        parmClass: "s",
        parmValue: username,
      },
      {
        parmClass: "s",
        parmValue: path,
      },
      {
        parmClass: "s",
        parmValue: type,
      },
    ],
  });
};
/**
 * @description: 拉起微信
 * @param {*} iosOpenWx
 * @return {*}
 */
export const iosOpenWx = () => {
  setNativeInfo({
    targetClass,
    methodType: 1,
    methodName: "openWxApp",
  });
};
/**
 * @description: 获取刘海屏高度
 * @param {*} anGetHeaderHeight
 * @return {*}
 */
export const iosGetHeaderHeight = () => {
  return getSyncNativeInfo({
    targetClass,
    methodType: 1,
    methodName: "getNaviTypeConfig",
  });
};
/**
 * @description: 获取手机号码
 * @param {*} iosGetPhone
 * @return {*}
 */
export const iosGetPhone = () => {
  return getSyncNativeInfo({
    targetClass: "KUserCenter",
    methodType: 1,
    methodName: "phone",
  });
};
/**
 * @description: 拉起分享面板
 * @param {*} iosSharePanel
 * @return {*}
 */
export const iosSharePanel = () => {
  setNativeInfo({
    targetClass: "",
    methodName: "hzwRightButtonClicked",
  });
};
/**
 * @description: 拉起微信支付分
 * @param {*} iosWxpayScore
 * @return {*}
 */
export const iosWxpayScore = ({
  businessType,
  queryString,
  minType = 0,
} = {}) => {
  setNativeInfo({
    targetClass,
    methodType: 1,
    methodName: "pushWxBussinessWithQurey_bussinessType_miniProgramType_",
    parm: [
      {
        parmClass: "s",
        parmValue: queryString,
      },
      {
        parmClass: "s",
        parmValue: businessType,
      },
      {
        parmClass: "s",
        parmValue: minType,
      },
    ],
  });
};
/**
 * @description: 设置标题栏样式
 * @param {*} iosSetHeaderStyle
 * @return {*}
 */
export const iosSetHeaderStyle = (value) => {
  setNativeInfo({
    targetClass: "",
    methodName: "channelPlazaSetConfig_",
    parm: [
      {
        parmClass: "m",
        parmValue: value,
      },
    ],
  });
};

// 关闭当前页
export const iosCloseWindow = () => {
  setNativeInfo({
    targetClass: "",
    methodType: 0,
    methodName: "closeAction",
    parm: [],
  });
};

/**
 * @description: 隐藏app的返回按钮
 * @param {*} iosSetBackBtnHide
 * @return {*}
 */
export const iosSetBackBtnHide = (value => {
  setNativeInfo(
    {
      targetClass: 'self',
      methodName: 'setBackVisible_',
      methodType: '0',
      params: [{ parmClass: 's', parmValue: '0' }]
    }
  )
})

/**
 * @description: 检查是否开启 push 提醒
 * @param {*} iosCheckPushSetting
 * @return {*}
 */
 export const iosCheckPushSetting = (() => {
  return getSyncNativeInfo(
    {
      targetClass: 'KPushGuideManager',
      methodType: '0',
      methodName: 'getPushOpenedStatus',
      methodArgsTypes: 't,b'
    }
  )
})

/**
 * @description: 跳转 push 提醒权限设置
 * @param {*} iosOpenPushSetting
 * @return {*}
 */
 export const iosOpenPushSetting = (() => {
  return getSyncNativeInfo(
    {
      targetClass: 'KPushGuideManager',
      methodType: '1',
      methodName: 'gotoAppConfigSetting'
    }
  )
})
